
<div class="about">

  <h2>Firebase & AngularFire In Depth</h2>

  <img class="course-image mat-elevation-z10"
       src="https://angular-university.s3-us-west-1.amazonaws.com/course-images/firebase-course-1.jpg">


    <button mat-raised-button class="upload-btn" color="primary" (click)="uploadData()">Populate Database</button>

</div>


